var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMailLine(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6 0.400024C12.9532 0.399913 13.2934 0.533309 13.5524 0.773472C13.8114 1.01364 13.97 1.34282 13.9965 1.69502L14 1.80002V10.2C14.0001 10.5532 13.8667 10.8934 13.6266 11.1524C13.3864 11.4114 13.0572 11.57 12.705 11.5965L12.6 11.6H1.4C1.0468 11.6001 0.706603 11.4667 0.447616 11.2266C0.18863 10.9864 0.0299904 10.6572 0.00350015 10.305L7.01876e-08 10.2V1.80002C-0.000111705 1.44682 0.133285 1.10663 0.373448 0.847641C0.613611 0.588654 0.942791 0.430015 1.295 0.403525L1.4 0.400024H12.6ZM12.6 2.78982L7.742 7.64782C7.54512 7.84445 7.27825 7.9549 7 7.9549C6.72175 7.9549 6.45487 7.84445 6.258 7.64782L1.4 2.78982V10.2H12.6V2.78982ZM11.6102 1.80002H2.3898L7 6.41022L11.6102 1.80002Z",
    fill: "#515159"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailLine);
export default __webpack_public_path__ + "static/media/mail_line.d8bfee40c4ff0e2a113948f76209f8a5.svg";
export { ForwardRef as ReactComponent };